import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-6 md:px-10 py-20 md:py-28 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20office%20team%20collaborating%20happily%20around%20large%20display%2C%20warm%20evening%20light%2C%20golden%20amber%20tones%2C%20inspiring%20workplace%20atmosphere%2C%20soft%20depth%20of%20field%2C%20editorial%20photography&width=1920&height=600&seq=cta-bg-01&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/65 to-foreground-950/75"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-5">
          准备好提升团队协作效率了吗？
        </h2>
        <p className="text-base text-background-50/75 mb-10 max-w-xl mx-auto leading-relaxed">
          注册免费账号，立即体验多人实时协同起草的便捷。无需安装，打开浏览器即可开始协作。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/#"
            className="w-full sm:w-auto text-center whitespace-nowrap px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-md hover:bg-primary-600 transition-all duration-200 text-base no-underline"
          >
            免费开始使用
          </Link>
          <Link
            to="/about#contact"
            className="w-full sm:w-auto text-center whitespace-nowrap px-8 py-3.5 border border-background-50/30 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-all duration-200 text-base no-underline"
          >
            联系销售
          </Link>
        </div>
      </div>
    </section>
  );
}